import React, { useState } from "react";
import { createPortal } from "react-dom";
import { CheckCircle2 } from "lucide-react";
import { visitKey } from "./techData";

const fmt = (d) => (d || "").slice(0, 10).split("-").reverse().join("/");

// shown after "Work Order Completed": what was set up, then offer the "on my way" text to the next job
export default function CompletePopup({ res, me, texted, date, nav }) {
  const [ask, setAsk] = useState(false);
  const next = res?.next_job;
  const onway = () => {
    const init = { client_id: next.client_id, reminder_id: next.reminder_id, date };
    nav.go("onway", { clientId: next.client_id, visitId: visitKey({ id: next.reminder_id }, next.client_id, date), init });
  };
  const ok = () => (next ? setAsk(true) : nav.home());
  return createPortal(
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" data-testid="tech-complete-popup">
      <div className="w-full max-w-md bg-white rounded-3xl p-5 space-y-4 shadow-xl">
        <CheckCircle2 className="h-14 w-14 text-green-600 mx-auto" />
        {!ask ? <>
          <div className="text-[18px] leading-snug text-slate-800 space-y-2" data-testid="tech-complete-msg">
            {res ? <p>Thanks {me}, a reminder has been set for {res.kevin || "Kevin"} to Validate &amp; Invoice Client if required.</p>
              : <p>Thanks {me}. No signal right now - the work order will be completed and {`Kevin's`} reminder set as soon as you have signal.</p>}
            {res?.next_service && <p>Your next scheduled service ({fmt(res.next_service.date)}, W/O {res.next_service.wo_number}) has been added to your reminders and magnet placed on the whiteboard.</p>}
            {res?.next_reason && <p className="font-bold text-red-700" data-testid="tech-complete-nonext">{res.next_reason}</p>}
            {texted ? <p>A text was also sent from your phone to the client, letting them know you have completed the job.</p>
              : <p className="font-bold text-amber-700">There's no mobile number for this client, so no text was sent.</p>}
          </div>
          <button onClick={ok} data-testid="tech-complete-ok" className="w-full h-14 rounded-2xl bg-[#0f2f52] text-white text-[19px] font-black">OK</button>
        </> : <>
          <div className="text-[19px] font-bold text-slate-800 text-center" data-testid="tech-complete-ask">Do you want me to send a text to your next job ({next.name}) letting them know you are on your way?</div>
          <div className="grid grid-cols-2 gap-3">
            <button onClick={nav.home} data-testid="tech-complete-no" className="h-14 rounded-2xl bg-slate-200 text-slate-800 text-[19px] font-black">No</button>
            <button onClick={onway} data-testid="tech-complete-yes" className="h-14 rounded-2xl bg-green-600 text-white text-[19px] font-black">Yes</button>
          </div>
        </>}
      </div>
    </div>, document.body
  );
}
